<template>
  <div>
    <h2 class="kojin-title pc_only"><slot>タイトル</slot></h2>
  </div>
    <span class="sp_only">
      <span class="sp-title" style="color:#FFF;background: #4169e1;">
        <slot>タイトル</slot>
        
          <input type="text" class="form-control" v-if="GlobalData.user_name" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
          
      </span>
      
    <!-- 新規登録・ログインボタン（スマホのみ） -->
    <div class="sp_button_area" v-if="login_status == false" style="text-align:center;padding-bottom:10px;
      flex-direction: row;
        justify-content: center;">
      <button class="btn btn-primary mx-aut" style="font-size: 13.5px;width: 200px; height: 40px;margin:0 5px 10px 5px;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000" v-on:click="user_signin()">新規登録</button>
      <br>
      <button class="btn btn-primary mx-aut" style="font-size: 13.5px;width: 200px; height: 40px;margin:0 5px 10px 5px;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000" v-on:click="login()">ログイン</button>
     </div>

     <div class="sp_button_area" style="text-align:center;padding-bottom:10px;
        flex-direction: row;
        justify-content: center;"
        v-if="jizen_dsp == 1">
      <button class="btn btn-secondary mx-aut" style="font-size: 13.5px;width: 200px; height: 40px;margin:0 5px 10px 5px;padding: 0;background-color: #FF8400;color:white;border:1px solid #000" v-on:click="jizen_list()">事前研修一覧</button>
      <br>
    </div>

    </span>
    <div v-if="GlobalData.$taiken_flow == 1" style="color:red;margin:10px 0">
      <b >事前研修参加後より申込可能となります。</b>
    </div>
  <div class="p-2 " style="margin-top:0;background-color:white">
    
    
    <!-- ユーザー登録後アンケート未回答の場合（実施する場合のみ） -->
     <!-- 各文言はuserdata.jsより -->
     <div v-if="enqete_ok == 0" style="text-align:center">
     {{GlobalData.$enqete_mikaitou}}<br>
      <span v-on:click="move_enqete" style="color:red;cursor: pointer;"><u>{{GlobalData.$enqete_link}}</u></span><br>
      <hr style="width:100%">
    </div>
    <div v-if="midoku_count!=0" class="pc_only" style="color:red;cursor: pointer;" :onclick="move_notification">
      <u>
        未読のお知らせが {{midoku_count}} 件あります。
      </u>
     </div>

    <!-- パンくずリスト -->
    <nav class="pc_only" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>{{ev}}
        <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
      </ol>
    </nav>
    
    <div id="manual_area">

      <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />体験プログラムのマニュアル</span>
      <span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

    </div>

    <br clear="all">
    <div class="sp_only" style="text-align:center;padding: 5px;text-align: left;font-size: 0.9rem;">
      <span style="color:red">プログラム番号：名称をタップしてください。</span><br>
      （<span style="color:#4169e1">青枠下線部</span>）
     </div>
    <!-- PC時は全件数、ページ選択、表示件数を表示 -->
  <div class="pg_list_page" style="padding: 0 5px;">

    <div style="width:25%">
      <span style="display:flex;align-items: center;"><b style="font-size: 20px;padding-right: 5px">{{ kensu }}</b> 件見つかりました</span>
    </div>

    <div style="width:50%;display: flex;justify-content: center;align-items: center;margin:0 auto">
        <div style="float:left;cursor:pointer" v-on:click="top">最初へ&nbsp;&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="back">前へ&nbsp;&nbsp;</div>
        <div v-for="i in tm" :key="i" style="float:left;cursor:pointer" v-on:click="page(i)">&nbsp;{{i}}&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="forward">&nbsp;&nbsp;次へ</div>
        <div style="float:left;cursor:pointer" v-on:click="last">&nbsp;&nbsp;最後へ</div>
    </div>
    
    <div style="width:25%;display: flex;align-items: center;justify-content: flex-end;">
      
      <span style="display:flex;float: right;">
        表示件数：
        <select v-model="gyo_count" v-on:change="gyo_change">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
          <option value="50">50</option>
        </select>
      </span>
    </div>
  </div>

    
  <!--スマホ時は件数のみ表示-->
  <div class="sp_only" style="width:100%;padding-left:5px;">
      <span style="display:flex;align-items: center;">検索結果 <b style="padding:0 10px">{{ kensu }}</b> 件</span>
  </div>

    <!-- 体験プログラム概要 -->
    <div align="left" v-for="(pg,i) in program.slice(st-1,ed)" v-bind:key="pg.id">
    <div v-bind:class="{'hov':over(i) == false,'hov_over':over(i) == true}" style="padding:4px;margin-bottom: 12px;">
    <table border="1" rules="all"  style="width:100%;border-collapse:collapse;">
      <tr v-on:click="shosai(i,pg.teiin_flg)">
        <td style="font-size:16px;background-color:white;display:flex;align-items: center;justify-content: space-between;">
          <div style="float:left"><b>{{pg.bunrui1 }}</b><br>
           <span v-if="list_disp[1] == 1"> {{pg.bunrui2 }} </span>
          </div>

          <div v-if="pg.teiin_flg == 1" style="float:right">
            
           <img  src="../../images/max2.png" alt="満員御礼" style="height:45px" />
          </div>
        </td>
      </tr>
      <tr v-on:click="shosai(i,pg.teiin_flg)"><td style="padding:2pt 6pt;background-color:royalblue;color:white;border-bottom: 1px solid #FFF;display: flex;justify-content: flex-start;align-items: center;">
        <div style="font-size:20px;"><u>{{ pg.taiken_no }}：{{pg.name }}</u></div>
      </td></tr>

      <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[9] == 1 && pg.k_name != '' && pg.k_name != null">
        <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
          <div   style="display: flex;align-items: center;">
            <b style="width:73px" class="pc_only">開催地名</b>
            <b style="width:10%;min-width:70px" class="sp_only">開催地名</b>
            <div class="program_naiyo">{{pg.k_name}}</div>
          </div>
        </td>

      </tr>
      <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[3] == 1">
        <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
          <div   style="display: flex;align-items: center;">
            <b style="width:73px" class="pc_only">施設住所</b>
            <b style="width:10%;min-width:70px" class="sp_only">施設住所</b>
            <div class="program_naiyo">{{pg.k_jusyo}}</div>
          </div>
        </td>

      </tr>
      <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[10] == 1 && pg.k_tel != '' && pg.k_tel != null">
        <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
          <div   style="display: flex;align-items: center;">
            <b style="width:73px" class="pc_only">連絡先</b>
            <b style="width:10%;min-width:70px" class="sp_only">連絡先</b>
            <div class="program_naiyo">{{pg.k_tel}}</div>
          </div>
        </td>

      </tr>
      <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[4] == 1">
        <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
          <div style="display: flex;align-items: center;">
            
            <b style="width:73px" class="pc_only">活動内容</b>
            <b style="width:10%;min-width:70px" class="sp_only">活動内容</b>
            <div class="program_naiyo">{{pg.naiyou}}</div>
          </div>
        </td>

      </tr>
      
      <template v-for="(result,i2) in nittei[i + ((current_page -1 ) * gyo_count)]" v-bind:key="i2">
      <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[5] == 1">
        <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
          <div   style="display: flex;align-items: center;">
            <span v-if="i2 != 0"></span>
              <template v-if="pg.shubetsu == 1">

                <template  v-if="nittei[i + ((current_page -1 ) * gyo_count)].length == 1">
                  <b style="width:73px" class="pc_only">日程</b>
                  <b style="width:10%;min-width:70px" class="sp_only">日程</b>
                </template>
                <template v-else>
                  <b style="width:73px" class="pc_only">日程{{ (i2+1) }}</b>
                  <b style="width:10%;min-width:70px" class="sp_only">日程{{ (i2+1) }}</b>

                </template>
                  <div class="program_naiyo">
                    
                    <b>開催日：</b>{{DateSetting(result.kaisai_start)}} <span v-if="result.kaisai_end && result.kaisai_end != result.kaisai_start">～{{DateSetting(result.kaisai_end)}}</span><br>

                    <b>開催時間：</b><span v-if="result.jikantai_start">{{TimeSetting(result.jikantai_start)}} ～ {{TimeSetting(result.jikantai_end)}}</span><br> 
                    <span v-if="(result.kaisai_youbi != null)"><b>開催曜日：</b>{{youbi_irekae(result.kaisai_youbi)}} <br></span>
                    <span v-if="(result.jogai != null)"><b>除外曜日：</b>{{youbi_irekae(result.jogai)}} <br></span>
                    <span v-if="(result.jogai_date != null)"><b>除外日：</b>{{result.jogai_date}} <br></span>
                    <b>定員：</b><span v-if="result.teiin >= 999">無し</span><span v-else-if="result.teiin">{{result.teiin}} 名</span><br>
                    <span v-if="(result.comment != null)"><b>コメント：</b>{{ result.comment }}</span>
                  </div>
              </template>
              <template v-else>
                    
                  <b style="width:73px" class="pc_only">開催期間</b>
                  <b style="width:10%;min-width:70px" class="sp_only">開催期間</b>
                  <div class="program_naiyo">
                    {{DateSetting(result.kaisai_start)}} <span v-if="result.kaisai_end && result.kaisai_end != result.kaisai_start">～{{DateSetting(result.kaisai_end)}}</span><br>

                  </div>
              </template>
          </div>
        </td>
      </tr>
    </template>
    <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="pg.bikou !='' && pg.bikou != null">
        <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
          <div style="display: flex;align-items: center;">
            
            <b style="width:73px" class="pc_only">特記事項</b>
            <b style="width:10%;min-width:70px" class="sp_only">特記事項</b>
            <div class="program_naiyo" style="color:red">{{pg.bikou}}</div>
          </div>
        </td>

      </tr>
      <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="pg.shubetsu==1 && list_disp[6] == 1">
        <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
          
            
            <div style="display: flex;align-items: center;">
              <template  v-if="(pg.nissu_min != '' || pg.nissu_min != null ) && (pg.nissu_max != '' || pg.nissu_max != null ) ">
              <b style="width:73px" class="pc_only">活動日数</b>
              <b style="width:10%;min-width:70px" class="sp_only">活動日数</b>
              <div class="program_naiyo">
                
                <span v-if=" pg.nissu_min == pg.nissu_max ">
                {{ pg.nissu_min  }}日
              </span>
              <span v-else-if="pg.nissu_min != pg.nissu_max ">
                <span v-if="pg.nissu_max == '' || pg.nissu_max == null ">
                  {{ pg.nissu_min  }}日以上
                </span>
                <span v-else-if="pg.nissu_min == '' || pg.nissu_min == null ">
                  {{ pg.nissu_max  }}日以下
                </span>
                <span v-else>
                  {{pg.nissu_min}} ～ {{pg.nissu_max}}日
                </span>
                </span>&nbsp;&nbsp;
                <span v-if="pg.nissu_joken == 1">連続</span>
              </div>
            </template>
            </div>

          </td>

        </tr>
        <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[7] == 1">
          <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
            <div style="display: flex;align-items: center;">
            <b style="width:73px" class="pc_only">参加条件</b>
            <b style="width:10%;min-width:70px" class="sp_only">参加条件</b>
            <div class="program_naiyo">
              
                <template v-if="(pg.joken_syogaku != '〇' && pg.joken_syogaku != 'ー' ) || pg.joken_syogaku == '〇'">
                  小:{{ pg.joken_syogaku }}<template v-if="pg.joken_syogaku != '〇' && pg.joken_syogaku != 'ー' ">年生</template>
                  <!-- 後続が一つでも存在していたら読点で区切る -->
                          <template v-if="((pg.joken_chugaku != '〇' && pg.joken_chugaku != 'ー') || pg.joken_chugaku == '〇') ||
                                    ((pg.joken_koukou != '〇' && pg.joken_koukou != 'ー') || pg.joken_koukou == '〇')||
                                    ((pg.joken_daigaku != '〇' && pg.joken_daigaku != 'ー') || pg.joken_daigaku == '〇')||
                                    ((pg.joken_sonota != '〇' && pg.joken_sonota != 'ー') || pg.joken_sonota == '〇')">
                          、
                      </template>
                    </template>
                    <template v-if="(pg.joken_chugaku != '〇' && pg.joken_chugaku != 'ー') || pg.joken_chugaku == '〇'">
                      中:{{ pg.joken_chugaku }}<template v-if="pg.joken_chugaku != '〇' && pg.joken_chugaku != 'ー' ">年生</template>
                      <!-- 後続が一つでも存在していたら読点で区切る -->
                      <template v-if="((pg.joken_koukou != '〇' && pg.joken_koukou != 'ー') || pg.joken_koukou == '〇')||
                                  ((pg.joken_daigaku != '〇' && pg.joken_daigaku != 'ー') || pg.joken_daigaku == '〇')||
                                  ((pg.joken_sonota != '〇' && pg.joken_sonota != 'ー') || pg.joken_sonota == '〇')">
                        、
                      </template>
                    </template>
                    <template v-if="(pg.joken_koukou != '〇' && pg.joken_koukou != 'ー') || pg.joken_koukou == '〇'">
                      高:{{ pg.joken_koukou }}<template v-if="pg.joken_koukou != '〇' && pg.joken_koukou != 'ー' ">年生</template>
                      
                      <!-- 後続が一つでも存在していたら読点で区切る -->
                      <template v-if="((pg.joken_daigaku != '〇' && pg.joken_daigaku != 'ー') || pg.joken_daigaku == '〇')||
                                  ((pg.joken_sonota != '〇' && pg.joken_sonota != 'ー') || pg.joken_sonota == '〇')">
                        、
                      </template>
                    </template>
                   
                    <template v-if="(pg.joken_daigaku != '〇' && pg.joken_daigaku != 'ー') || pg.joken_daigaku == '〇'">
                      専・大・大院:{{ pg.joken_daigaku }}<template v-if="pg.joken_daigaku != '〇' && pg.joken_daigaku != 'ー' ">年生</template>
                      <!-- 後続が一つでも存在していたら読点で区切る -->
                      <template v-if="((pg.joken_sonota != '〇' && pg.joken_sonota != 'ー') || pg.joken_sonota == '〇')">
                        、
                      </template>
                    </template>
                   
                    <template v-if="(pg.joken_sonota != '〇' && pg.joken_sonota != 'ー') || pg.joken_sonota == '〇'">他:{{ pg.joken_sonota }}
                    </template>
            </div>
          </div>
        </td>

      </tr>
      <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[8] == 1">
        
        <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
          
          <div style="display: flex;align-items: center;">
            <b style="width:73px" class="pc_only">申込〆切</b>
            <b style="width:10%;min-width:70px" class="sp_only">申込〆切</b>
            <div class="program_naiyo">
              
              <!--
              〆切日パターン
              1:事業単位で〆切日を設定（end_shubetsu == 1）＝事業全体の受付〆切日
              2:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日を設定している＝プログラムの受付〆切日
              3:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日が設定されていない＝申込日の〇日前まで申込可能
              -->
              <template v-if="end_shubetsu == 1">
                {{DateTimeSetting(end_datetime)}}
              </template>
              <template v-else-if="pg.shimekiri_date">{{EuDateTimeSetting(pg.shimekiri_date)}}</template>
              <template v-else>開催日の{{pg.shimekiri_nissu}}日前まで申込可能</template>
              <template v-if="over(i) == true">
                <br><b style="color:red;">受付は終了しました。</b>
              </template>
            </div>
          </div>
        </td>
    
      </tr>
    </table></div>
    </div><br/>
    
    <div class="pg_list_page" style="width:100%;justify-content: center;margin:0 auto">
        <div style="float:left;cursor:pointer" v-on:click="top">最初へ&nbsp;&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="back">前へ&nbsp;&nbsp;</div>
        <div v-for="i in tm" :key="i" style="float:left;cursor:pointer" v-on:click="page(i)">&nbsp;{{i}}&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="forward">&nbsp;&nbsp;次へ</div>
        <div style="float:left;cursor:pointer" v-on:click="last">&nbsp;&nbsp;最後へ</div>
    </div><br/>
  </div>
     
      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>

            
</template>

<script setup>
/* eslint-disable */ 
import { useRouter,useRoute } from 'vue-router'
import { DateSetting,DateTimeSetting,TimeSetting,ShimekiriSetting,EuDateTimeSetting,EuShimekiriSetting,youbi_irekae,GlobalData } from '../js/userdata.js'

import axios from 'axios'
import { ref, computed } from 'vue';
/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

import { useStore } from 'vuex'
const store = useStore()
let current_page = ref(store.state.current_page)
//const fileInput = ref(null);
const router = useRouter()
const route = useRoute()

const prop = defineProps(['param'])
let program = prop.param.program
let nittei = prop.param.nittei

let disp_nittei = ref([])


if(nittei){
  
  for (let n = 0;n<nittei.length;n++){
    let program_nittei = nittei[n]

    let set_nittei_text = []
    for(let p = 0;p<program_nittei.length;p++){
      let once = program_nittei[p]


      //alert(once.jisseki_id+"/"+once.taiken_id+" "+once.kaisai_start+"～"+once.kaisai_end+","+once.jikantai_start+"～"+once.jikantai_end)

      /*

      let set_text = ""

      set_text += DateSetting(once.kaisai_start);
      
      if(once.kaisai_end && once.kaisai_end != once.kaisai_start){
        set_text += "～"+DateSetting(once.kaisai_end)+" "
      }
      set_text += TimeSetting(once.jikantai_start) ;
      
      if(once.jikantai_end && once.jikantai_end != once.jikantai_start){
        set_text += "～"+TimeSetting(once.jikantai_end)+" "
      }

      if(once.kaisai_youbi){
        set_text += "※ "+once.kaisai_youbi+"のみ開催 "
      }
      if(once.jogai && once.jogai_date){
        set_text += "※ "+once.jogai_date+"と"+once.jogai+"を除く "
      }else{
        if(once.jogai ){
          set_text += "※ "+once.jogai+"を除く "
        }
        if(once.jogai_date){
          set_text += "※ "+once.jogai_date+"を除く"
        }
      }

      set_nittei_text[p] = set_text*/
    }
    /*
    disp_nittei.value[disp_nittei.value.length] = set_nittei_text*/
  }

}
//const cityname = prop.param.cityname
const cityname = route.params.shakyo

const midoku_count = ref(prop.param.midoku_count)

// ユーザーが本来所属する社協の名前
let shozoku_name = ref(prop.param.shozoku_name)

// アンケート回答済みかどうか（0：未回答、1：回答済み、2：回答の必要なし）
let enqete_ok = ref(GlobalData.enqete_flg)

// 今日の日付
let today = new Date()

// 受付〆切日の種別（1:事業単位、2:プログラム単位）
let end_shubetsu = ref(1)
// 受付〆切日時
let end_datetime = ref(new Date(today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate()+" 23:59:59"))


// 申し込み可能回数を利用するかどうか（1:する、2:しない）
let program_shubetsu = ref(2)

// 申し込み可能回数
let program_count = ref(5)
/*

// ファイル名を指定してユーザー登録後アンケートの回答CSVを取得し、ユーザーが回答しているかをチェックする
let answer_check_error = 0
let Form_answer_check = function() { 

  if(GlobalData.user_id != null){
      let set_url = GlobalData.$API_URL + "Form_read"
      axios.post(set_url,
      {
          shakyo:route.params.shakyo,
          file_name:"enqete/answer1.csv"
      }) 
      .then(response => {
          let update_file = response.data.csv_data
          let csv = update_file.split("\n");

          // ヘッダーから体験ユーザーIDの列番地を取得
          let header_row = csv[1].split(" ").filter(Boolean);
          let id_banchi = 0
          for ( const [index, kind] of header_row.entries()) {
              if(kind == "user_id")  id_banchi = index
          }

          // ヘッダーより下の行を確認
          // 該当するユーザーIDがあればOK
          let ok_flg = 0
          for(let c = 2;c<csv.length;c++){
              let csv_row = csv[c].split(" ").filter(Boolean);

              if(csv_row[id_banchi] == GlobalData.user_id) {
                ok_flg = 1
              }
          }

          if(ok_flg == 1){
            enqete_ok.value = 1
          }else{
            // なければアンケート未回答状態にする
            enqete_ok.value = 0
          }

      })
      .catch(error => {
        if(answer_check_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "answer_error";
            contentMessage.value = MessageModal
        }else{
            answer_check_error++
            setTimeout(function(){
              Form_answer_check()
            },"1000")
        }
      })
  }else{
      enqete_ok.value = 2
  }
}
*/
let kensu = 0

if(program.length != 0){
  kensu =program[0].all_count
}
const emit = defineEmits(['call'])

// ログイン状態
let login_status = ref(true)

// 表示フラグ
// 分類1（固定）
// 分類2
// プログラム名（固定）
// 施設住所
// 活動内容
// 実施期間
// 活動日数
// 参加条件
// 申込〆切
// 開催地名
// 連絡先
let list_disp = ref([0,0,0,0,0,0,0,0,0,0,0])

// 社協名
let shakyo_name = "";


  // 曜日配列
  const youbi_list = ["日","月","火","水","木","金","土"]

// 表示件数
const gyo_count = ref(store.state.gyo_count)

// スマホの時は１ページ目かつ全件（10000）
if (document.getElementById("app").clientWidth < 962) {
  
  current_page.value = 1
  gyo_count.value = 10000
}

// 表示件数を変えたら保持
const gyo_change = ()  => {
  store.state.gyo_count = gyo_count.value

  // 1ページ目に戻す
  top()
}

const st = ref(1)

let ed = ref(Math.min(parseInt(gyo_count.value), program.length+1))
const tm = computed(() => {
    st.value = 1
    ed.value = Math.min(parseInt(gyo_count.value), program.length+1);
    return Math.ceil(program.length / parseInt(gyo_count.value));
})
//-------- ページネーション -------------------
const top     = ()  => { st.value = 1
                         ed.value = st.value+parseInt(gyo_count.value)-1
                         current_page.value = 1
                         page_change(1)                         
                         emit('call',{ cmd:'page_scroll' }) }
const back    = ()  => { st.value = Math.max(1,st.value-parseInt(gyo_count.value))
                         ed.value = st.value+parseInt(gyo_count.value)-1 
                        let set_page = current_page.value
                        // 現在ページ数から1引いたら0にならない場合はマイナスする
                        if( (set_page-1 ) != 0){
                          set_page = set_page - 1
                        }
                         page_change(set_page)
                         emit('call',{ cmd:'page_scroll' })}
const page    = (i) => { st.value = (i-1)*parseInt(gyo_count.value)+1;
                         ed.value = Math.min(i*parseInt(gyo_count.value), program.length+1);
                         page_change(i)
                         emit('call',{ cmd:'page_scroll' })}
const forward = ()  => { st.value += parseInt(gyo_count.value);

                         let set_page = current_page.value

                         // 加算後の表示件数が全件数を超える場合は減算して戻す
                         if (st.value > program.length) { 
                          st.value -= parseInt(gyo_count.value)
                         }else{
                          // 加算後の表示件数が全件数を超えない場合はページを加算する
                          set_page = set_page + 1
                         }
                         ed.value = Math.min( st.value+parseInt(gyo_count.value)-1, program.length) 
                         page_change(set_page)
                         emit('call',{ cmd:'page_scroll' })}
const last    = ()  => { st.value = Math.max(1,program.length-parseInt(gyo_count.value)+1)
                         ed.value = Math.min(st.value+parseInt(gyo_count.value), program.length) 
                         // 全件数 / 表示件数を切り上げたものが最後のページ
                         page_change(Math.ceil(program.length / parseInt(gyo_count.value)))
                         emit('call',{ cmd:'page_scroll' })}
setTimeout(function(){ page(current_page.value) }, "100");

let page_change = function(page){
  current_page.value = page
  store.state.current_page = page
}

//------------------- 締切日を過ぎていれば赤で表示する
const over = (i) => {


  let today = new Date()
  // 一旦事業単位の受付〆切日を格納
  let check_shimekiri = new Date()

  // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されてる場合はそちらを確認する
  if(end_shubetsu.value == 2 && program[i+st.value-1].shimekiri_date){
    check_shimekiri = EuShimekiriSetting(program[i+st.value-1].shimekiri_date)
  }else if(end_shubetsu.value == 1){
      // 受付〆切日種別が1（事業単位）なら事業単位の日付を入力
      check_shimekiri = ShimekiriSetting(end_datetime.value)
    
  }else{
    // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されていない場合は終了
    return false
  }

  if (check_shimekiri >= today) {
      return false
  } else {
      return true
  }
}
//------------------- 体験プログラム詳細表示へ
const shosai = (i,teiin_flg) => { 

  let today = new Date()

  let check_shimekiri = new Date()

  // アンケート未回答の場合は入れない
  if(enqete_ok.value == 0){
    message.value = GlobalData.$enqete_mikaitou
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "enqete_error";
    contentMessage.value = MessageModal
    return
  }
  

  if(end_shubetsu.value == 1){
    
    check_shimekiri = end_datetime.value
  }else{
    if( teiin_flg == 1){
      message.value = "このプログラムは満員です。"
      message_cat.value = 0;
      message_flag.value = true;
      message_method.value = "read_error";
      contentMessage.value = MessageModal
      return
    }
    let shimekiri = new Date(end_datetime.value)

    // 〆切日が設定されていたら比較に利用
    if(program[i+st.value-1].shimekiri_date){
      shimekiri = program[i+st.value-1].shimekiri_date
      shimekiri = shimekiri.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      shimekiri = new Date(shimekiri);
      shimekiri.setHours(shimekiri.getHours());

      check_shimekiri = shimekiri
    }else{
      // 〆切日が設定されていなかったら今日の日付をそのまま入力(スルー)
//      check_shimekiri = end_datetime.value
    }
  }


    if (check_shimekiri >= today) {

      let sanka_flg = 0
      let sanka_count = 0
      let before_id = 0
      // 締切前なら体験プログラムの申し込み状況を確認
      // ついでに申込済みの体験プログラムをカウント
      for(let u = 0;u<user_taiken_jyokyo.length;u++){

        if(user_taiken_jyokyo[u].jokyo != 9){

          if(program[i+st.value-1].taiken_id == user_taiken_jyokyo[u].program_id){
            sanka_flg = 1
          }
          
          if(before_id != user_taiken_jyokyo[u].program_id){
            if(user_taiken_jyokyo[u].program_kbn == 1){
              sanka_count++
            }
          }
          before_id = user_taiken_jyokyo[u].program_id
        }
      }

      // 申込済みなら詳細ページへの進入不可
      if(sanka_flg == 1){
          message.value = "このプログラムは申込済です。"
          message_cat.value = 0;
          message_flag.value = true;
          message_method.value = "read_error";
          contentMessage.value = MessageModal

      }else{

        // 申し込み回数の上限が決まっている場合
        if(program_shubetsu.value == 1){

          // 申し込み回数がすでに上限以上の場合は進入不可
          if(program_count.value <= sanka_count ){
            message.value = "申し込み回数の上限に達しています。\n※このプログラムに参加したい場合は、他のプログラムを１つキャンセルする必要があります。"
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "read_error";
            contentMessage.value = MessageModal
            return
          }

        }
        router.push('/'+cityname+'/Taiken/detail/'+(program[i+st.value-1].taiken_id)) 

      }

    }
  
}


// お知らせへ移動
let move_notification = function(){
  
  router.push('/'+cityname+'/Taiken/notification') 
}

// ユーザー登録後アンケートへ移動
let move_enqete = function(){
  router.push('/'+cityname+'/Taiken/enqete/1') 

}


    // メッセージを表示するウィンドウでOKを押された時
    let OK_message = function(){ 
        Close_message();//メッセージを表示するウィンドウを閉じる
        
        if(message_method.value == "enqete_error"){
            // アンケート未回答の場合はアンケート画面へ
            move_enqete()
        }
    }

    // メッセージを表示するウィンドウを閉じる
    let Close_message = function(){
        message_flag.value = false;
        contentMessage.value = null
    }


//------------------- Googlemap（外部リンク）へ
const googlemap = (set_jusho) => { window.open("http://local.google.co.jp/maps?q="+set_jusho,"_blank") }

const dist = (e) => {
    alert("dist:"+e.clientX+","+e.clientY+" left,bottom:"+drg.value.left+","+drg.value.clientTop)
}
const home = () => { 
  // 体験フローが１（事前研修を先に申し込む）の場合はHOME画面へ戻す
  if(GlobalData.$taiken_flow == 1){
    router.push('/'+cityname+'/Taiken')
  }else{
    // 体験フローが２の場合は、この画面がHOMEなのでページを１に戻す
    store.state.current_page = 1;
    page(1)
  }
 }

const jizen_list = () =>{
  router.push('/'+cityname+'/Taiken/Jizen')
  
}

const login = function() {
   router.replace('/'+cityname+'/Taiken/login')
}

const user_signin = () => {
    router.replace('/'+cityname+'/Taiken/user_signin' )
}

// 所属社協へ移動する
const move_shozoku = () =>{
    location.href=location.protocol+'//'+location.host+"/"+GlobalData.shakyo_code+"/Taiken"
}

/* 初期処理 */
let user_taiken_jyokyo = []//ユーザーの体験プログラム申込状況を取得
if (GlobalData.$User_email) { // ログインしているかチェック
    if (GlobalData.user_id) { // ユーザー情報があるかチェック
            
        // ログイン中かつユーザー情報登録済みであればこのユーザーの体験プログラムの実績データを取得
        axios.post(GlobalData.$API_URL + "Taikenuser_Jisseki",
        {
           taikenuser_id: GlobalData.user_id,
           program_kbn:1
        },GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
          if(response.data["status"] == 1){
            alert("エラーが発生しました。\n"+response.data["message"])
          }else{
              user_taiken_jyokyo = response.data.jisseki

          }
        }).catch(error => {
          
        })
      }
    }else{
      login_status.value = false
    }

    // 表示設定と受付〆切日、社協名を取得
    axios.post(GlobalData.$API_URL+"Shakyo_read", 
            {shakyo:route.params.shakyo}
            ).then(response => {
           
              // 表示設定を取得
              list_disp.value = response["data"].program_list_disp.split(',')

              // 社協名を取得
              shakyo_name = response["data"].shakyo_name

              // 受付〆切日の種別を取得
              end_shubetsu.value = response["data"].end_shubetsu

            // 受付〆切日の確認
            if(response["data"].end_date){

              let set_time = " 23:59:59"
              if(response["data"].end_time != "" && response["data"].end_time != null) {
                set_time = response["data"].end_time
              }
              let end_date = new Date(response["data"].end_date + " "+set_time)
              end_date = end_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
              end_date = new Date(end_date);
              end_date.setHours(end_date.getHours());

              end_datetime.value = end_date

            }else{
              // 存在しない場合は今日の23時59分59秒まで

            }

            // 申し込み可能回数の確認
            if(response["data"].program_shubetsu == 1){
              program_shubetsu.value = response["data"].program_shubetsu
              program_count.value = response["data"].program_count

            }

            /*
            // ユーザー登録後アンケートの実施状況確認
            if(response["data"].enqete_shubetsu == 1){
              setTimeout(function(){Form_answer_check()},"1000")
            }else{
              enqete_ok.value = 2
            }*/
        })
        .catch(error => {
          
//            alert("社協情報の取得時にエラーが発生しました。"+error)
        })


    let jizen_dsp = ref(0)
  // 体験フロー１（事前研修を先に申し込む）の時は、申し込める事前研修があればボタンを表示
  if(GlobalData.$taiken_flow == 1){

        const today = new Date()
        let set_date = new Date(today);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date);
                
        let today_set = set_date.getFullYear()+"-"+(set_date.getMonth()+1)+"-"+set_date.getDate()

        // 今日以前に締め切った事前研修は除く
        let search_param = {"shimekiri_date":today_set}
        search_param.choson_code = cityname

        axios.post(GlobalData.$API_URL+"Jizen_get", search_param)
        .then(response => {
            
            let program = response.data.jizen
            let jizen_kensu = 0
            // 締め切られていない事前研修を取得
            if(program.length != 0){
                for(let i=0;i<program.length;i++){
                //   alert(JSON.stringify(program[i]))
                
                    let today = new Date()


                    let shimekiri = new Date(program[i].shimekiri_date +" 23:59:59")
                    
                    if (shimekiri >= today) {
                        jizen_kensu++
                    }
                }
            }


            // すべての事前研修が締め切られていたらボタンは表示しない
            if(jizen_kensu == 0){
            }else{
                jizen_dsp.value = 1
            }
        
        })
        .catch(error => {
            
        })
  }
    
  let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/161c0be34f8f80fc87baf85432ed7220"
    window.open(url,"_blank")
}

// Q&Aを開く
const qanda_open = () =>{

  let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
  window.open(url,"_blank")
}        
    
</script>
<style scoped>
.hov,.hov_over,.hov_over:hover {
  background-color: white;
  cursor: default;
}
.hov:hover {
  background-color:royalblue;
  cursor: pointer;

}

.list_bunrui {
  font-size: 14px;
}

.program_naiyo{
  width:90%;
  margin-left:10px
}
@media screen and (min-width: 961px) {

/* PC版 */

  .sp_button_area{
      display: none
  }
}
@media screen and (max-width: 960px) {

  /* スマホ版 */

  .sp_button_area{
      display: flex
  }
}
</style>
